import { Map as ImmutableMap } from 'immutable';
import * as ActionTypes from '../actions/ActionTypes';
import KnowledgeBaseSettingsRecord from 'knowledge-content-ui/records/KnowledgeBaseSettingsRecord';
import ThemeSettingsRecord from 'knowledge-content-ui/records/ThemeSettingsRecord';
// @ts-expect-error ts-migrate(7009) FIXME: 'new' expression, whose target lacks a construct s... Remove this comment to see the full error message
const INITIAL_STATE = new ImmutableMap([['knowledgeBaseSettings', new KnowledgeBaseSettingsRecord()], ['themeSettings', new ThemeSettingsRecord()], ['isFetched', false]]);
export default function templateSettings(state = INITIAL_STATE, {
  payload,
  type
}) {
  switch (type) {
    case ActionTypes.TEMPLATE_EDITOR_UPDATE_FORM_SUCCESS:
      return state.withMutations(s => {
        payload.changes.forEach(({
          keyPath,
          value
        }) => {
          s.setIn(keyPath, value);
        });
      });
    case ActionTypes.FETCH_TEMPLATE_SETTINGS_SUCCESS:
      return state.set('isFetched', true).set('knowledgeBaseSettings', new KnowledgeBaseSettingsRecord(Object.assign({}, payload.knowledgeBase))).set('themeSettings', new ThemeSettingsRecord(payload.themeSettingsValues.values));
    default:
      return state;
  }
}